import React from 'react';
import Tooltip from './Tooltip';

interface ServiceItemProps {
  icon: React.ReactNode;
  text: string;
  tooltips?: { [key: string]: string };
}

const ServiceItem: React.FC<ServiceItemProps> = ({ icon, text, tooltips = {} }) => {
  const renderTextWithTooltips = (text: string) => {
    if (Object.keys(tooltips).length === 0) {
      return text;
    }

    let processedText = text;
    const elements: React.ReactNode[] = [];
    let lastIndex = 0;

    Object.entries(tooltips).forEach(([term, explanation]) => {
      const index = processedText.toLowerCase().indexOf(term.toLowerCase());
      if (index !== -1) {
        // Add text before the term
        if (index > lastIndex) {
          elements.push(processedText.slice(lastIndex, index));
        }
        
        // Add the term with tooltip
        elements.push(
          <Tooltip key={term} content={explanation}>
            <span className="cursor-pointer primary-color font-medium">
              {processedText.slice(index, index + term.length)}
            </span>
          </Tooltip>
        );
        
        lastIndex = index + term.length;
      }
    });

    // Add remaining text
    if (lastIndex < processedText.length) {
      elements.push(processedText.slice(lastIndex));
    }

    return elements.length > 0 ? elements : text;
  };

  return (
    <div className="flex items-center gap-3 px-4 p-3 rounded-lg secondary-bg">
      {icon}
      <span className="primary-text">{renderTextWithTooltips(text)}</span>
    </div>
  );
};

export default ServiceItem;
